<template>
  <dialogModule
    top="15"
    width="500px"
    title="货品明细"
    v-if="ticketVisible"
    :dialogVisible="ticketVisible"
    @close="close">
    <span slot="close" class="el-icon-close close cursor" @click="close"></span>
    <section slot="content">
      <div class="goods row align-center space-between" v-for="(item, i) in currentTicket.goodInfos" :key="i">
        <div class="left row align-center">
          <div class="goods-img">
            <el-image v-if="item.imageList && item.imageList.length" class="img" :src="item.imageList[0]" :preview-src-list="item.imageList"></el-image>
            <div v-else class="row align-center space-center">暂无图片</div>
          </div>
          <div class="goods-attr">
            <div class="title">{{item.goodsName}}</div>
            <div class="spu">{{item.goodsNo}}</div>
            <div class="attr" v-if="item.attr">
              <span v-for="(val, v) in item.attr.slice(0, 2)" :key="v">{{val.value}}</span>
            </div>
          </div>
        </div>
        <div class="right row align-center">
          <div class="right-price">
            <div class="row align-center space-end tag-price">吊牌价：<span>{{item.tagPrice}}</span></div>
            <div class="row align-center space-end sell-price">当前零售价：<span>{{item.retailPrice}}</span></div>
            <div class="row align-center space-end real-price">实卖价：<span>{{item.realPrice}}</span></div>
          </div>
          <div class="num">{{item.number}}件</div>
        </div>
      </div>
      <div class="goods row align-center space-between" v-for="(item, i) in currentTicket.giftGoodInfos" :key="i + item.goodsNo">
        <div class="left row align-center">
          <div class="goods-img">
            <el-image v-if="item.imageList && item.imageList.length" class="img" :src="item.imageList[0]" :preview-src-list="item.imageList"></el-image>
            <div v-else class="row align-center space-center">暂无图片</div>
            <div class="label">赠送</div>
          </div>
          <div class="goods-attr">
            <div class="title">{{item.goodsName}}</div>
            <div class="spu">{{item.goodsNo}}</div>
            <div class="attr" v-if="item.attr">
              <span v-for="(val, v) in item.attr.slice(0, 2)" :key="v">{{val.value}}</span>
            </div>
          </div>
        </div>
        <div class="right row align-center">
          <div class="right-price">
            <div class="row align-center space-end tag-price">吊牌价：<span>{{item.tagPrice}}</span></div>
            <div class="row align-center space-end sell-price">当前零售价：<span>{{item.retailPrice}}</span></div>
            <div class="row align-center space-end real-price">实卖价：<span>{{item.realPrice}}</span></div>
          </div>
          <div class="num">{{item.number}}件</div>
        </div>
      </div>
    </section>
  </dialogModule>
</template>

<script>
import dialogModule from "@/components/dialogModule.vue"
export default {
  components: {
    dialogModule
  },
  props: {
    currentTicket: {
      type: null,
      default: () => null
    }
  },
  data() {
    return{
      ticketVisible: true,
      infoVisible: true
    }
  },
  methods: {
    close(){
      this.ticketVisible = false
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.goods{
  margin: 10px 20px;
  &:last-child{
    padding-bottom: 15px;
  }
  .left{
    .goods-img{
      overflow: hidden;
      margin-right: 10px;
      position: relative;
      .img{
        width: 80px;
        height: 80px;
        float: left;
        border-radius: 4px;
      }
      div{
        width: 80px;
        height: 80px;
        background: #eee;
        border-radius: 4px;
      }
      .label{
        top: 5px;
        color: #fff;
        width: 60px;
        right: -15px;
        height: 20px;
        font-size: 12px;
        position: absolute;
        text-align: center;
        transform: rotate(45deg);
        background: linear-gradient(0deg, #208aec, #02d7f0, #00c6f7);
      }
    }
    .goods-attr{
      .title{
        color: #000;
        font-size: 16px;
        margin-top: -4px;
        font-weight: bold;
      }
      .spu{
        color: #000;
        margin: 6px 0;
        font-size: 16px;
      }
      .attr{
        span{
          padding: 0 4px;
          border-radius: 2px;
          margin-right: 10px;
          border: 1px solid #aaa;
        }
      }
    }
  }
  .right{
    .right-price{
      color: #000;
      div{
        span{
          width: 60px;
          color: #666;
          text-align: right;
          font-weight: bold;
        }
      }
      .sell-price{
        margin: 6px 0;
      }
      .real-price{
        span{
          color: #000;
        }
      }
    }
    .num{
      color: #067CF2;
      font-size: 16px;
      font-weight: bold;
      margin-left: 20px;
    }
  }
}
</style>